export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[60%] h-full bg-gradient-to-l from-accent-500/8 via-accent-500/3 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-12 md:py-20">
          <div className="flex-1 w-full max-w-[640px] lg:max-w-none">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-300">每日更新 · 高清片源</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-50 leading-tight mb-4">
              8848影院
              <br />
              <span className="text-accent-400">高清电影免费在线观看平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-300 leading-relaxed max-w-[560px] mb-4 opacity-0 animate-fade-in-up animate-delay-200">
              动作片的凌厉、喜剧片的欢笑、经典老片的回味——尽在8848影院。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-[560px] mb-8 opacity-0 animate-fade-in-up animate-delay-300">
              8848影院电影大全涵盖最新电影、经典电影、动作片、喜剧片等各类高清影片，免费在线观看，
              片源丰富即点即播。无需注册，无需付费，随时随地畅享影院级观影体验。我们每日更新片库，
              紧跟全球电影潮流，让你永远有片可看。当前热推动作大片与高分喜剧专题，这个夏天不容错过。
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-10 mb-8 opacity-0 animate-fade-in-up animate-delay-400">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">20000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">高清片源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">新鲜片单</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">即点即播</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">流畅观影</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 opacity-0 animate-fade-in-up animate-delay-500">
              <a
                href="#index"
                className="px-8 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#carousel"
                className="px-8 py-3 text-sm font-medium text-foreground-300 border border-background-300/70 rounded-full hover:border-foreground-400 hover:text-foreground-200 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none opacity-0 animate-fade-in-up animate-delay-200">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-3xl blur-3xl"></div>
              <div className="relative grid grid-cols-2 gap-3 md:gap-4">
                <div className="space-y-3 md:space-y-4 pt-6">
                  <div className="rounded-xl overflow-hidden aspect-[3/4] bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20with%20intense%20dramatic%20lighting%20and%20warm%20golden%20tones%2C%20professional%20film%20poster%20aesthetic%2C%20dark%20atmospheric%20background%20with%20subtle%20texture%2C%20movie%20poster%20design%20style%2C%20high%20contrast%20cinematic%20look&width=600&height=800&seq=hero-film-01&orientation=portrait"
                      alt="动作电影海报"
                      className="w-full h-full object-cover object-top"
                      onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden aspect-[3/4] bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Classic%20vintage%20film%20poster%20with%20nostalgic%20warm%20sepia%20tones%2C%20elegant%20typography%20style%2C%20soft%20lighting%2C%20artistic%20golden%20age%20cinema%20aesthetic%2C%20rich%20textured%20background&width=600&height=800&seq=hero-film-02&orientation=portrait"
                      alt="经典电影海报"
                      className="w-full h-full object-cover object-top"
                      onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                    />
                  </div>
                </div>
                <div className="space-y-3 md:space-y-4">
                  <div className="rounded-xl overflow-hidden aspect-[3/4] bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Comedy%20film%20poster%20with%20bright%20vibrant%20warm%20colors%2C%20playful%20energetic%20design%2C%20cheerful%20cinematic%20aesthetic%2C%20clean%20minimal%20background%20with%20accent%20colors%2C%20modern%20movie%20poster%20style&width=600&height=800&seq=hero-film-03&orientation=portrait"
                      alt="喜剧电影海报"
                      className="w-full h-full object-cover object-top"
                      onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden aspect-[3/4] bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Drama%20film%20poster%20with%20emotional%20artistic%20composition%2C%20soft%20warm%20lighting%20and%20deep%20shadows%2C%20elegant%20minimalist%20cinematic%20design%2C%20textured%20dark%20background%20with%20subtle%20highlights&width=600&height=800&seq=hero-film-04&orientation=portrait"
                      alt="剧情电影海报"
                      className="w-full h-full object-cover object-top"
                      onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}